import { Helmet } from "react-helmet-async";
// @mui
import { Container } from "@mui/material";
import Document from "src/components/Document/Document";
// ----------------------------------------------------------------------

export default function PlannerDocument() {
  return (
    <>
      <Helmet>
        <title> PlannerDocument </title>
      </Helmet>

      <Container maxWidth="xl">
        <Document Role="Planner" />
      </Container>
    </>
  );
}
